var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"empty-page",style:(_vm.styles)},[_c('div',{staticClass:"empty-page__inner"},[_c('iv-icon',{attrs:{"type":_vm.icon,"size":"50"}}),_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._t("emptyBtn")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }